import React from 'react';
import { Skeleton, VStack } from 'native-base';
import { GIFTCARD_FLOWS, observer, useSpringBigStore } from '@springbig/shared';
import { Caption } from '~/shared/Typography';
import { Button } from '~/shared/Theme';

const Point = ({
    setIsSetNameModalOpen,
    setOnSubmitAction
}: {
    setIsSetNameModalOpen: (value: boolean) => void
    setOnSubmitAction: (value: GIFTCARD_FLOWS | undefined) => void
}) => {

    const { member, merchant, giftCards } = useSpringBigStore();

    const onConvertPointsToCash = () => {

        if (!member?.first_name || !member?.last_name || !member.confirmed_identity) {
            setIsSetNameModalOpen(true);
            setOnSubmitAction(GIFTCARD_FLOWS.convertPointsToCash);
        }
        else {
            observer.emit('open-actionsheet', GIFTCARD_FLOWS.convertPointsToCash);
        }
    };

    return (
        <VStack alignItems={'center'} justifyContent='center' flex={1} px={4} textAlign={'center'}>
            { (member.id || member?.balance) ?
                <Caption fontSize={36} fontWeight={'200'}>
                    { member?.balance || '0' }
                </Caption>
                :
                <Skeleton h={'2.5rem'} w={'8rem'} rounded={'lg'} mb={'1rem'}/>
            }
            <Caption fontSize={22} fontWeight={'100'} text='giftCard.balance.point_balance' />
            {
                merchant?.points_cash_conversion_enabled &&
                parseFloat(merchant.dollars_per_point) > 0 &&
                (!(giftCards.every(card => card.is_closed_loop)) || merchant?.create_gift_card_with_points) &&
            <Button
                text={'giftCard.balance.convert_points_cash'}
                variant={'neutral'}
                onPress={onConvertPointsToCash}
            />
            }
        </VStack>
    );
};

export default Point;
